<template>
  <form-layout :label="label" :required="required" :optional="optional">
    <check-box-list v-if="options.length !== 0" :options="options" :invalid="!!errorMessage" v-model="checked" />
    <div v-else :class="{'is-invalid': !!errorMessage, 'text-danger': !!errorMessage}">物件を選択してください</div>
    <div class="invalid-feedback">{{ errorMessage }}</div>
  </form-layout>
</template>
<script>
import BaseVuexFormItem from "@/views/molecules/formItems/BaseVuexFormItem";
import FormLayout from "@/views/templates/FormLayout";
import CheckBoxList from '@/views/atoms/inputs/CheckBoxList';

export default {
  name: "VuexIssueDocumentFormItem",
  extends: BaseVuexFormItem,
  components: {
    FormLayout,
    CheckBoxList,
  },
  props: {
    label: {
      type: String,
      default: '発行書類'
    },
    issueDocuments: {
      type: Array,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    checked: {
      get() {
        return this.issueDocuments.reduce((acc, doc) => {
          acc[doc.id] = doc.checked; // 画面のチェック状態をそのまま反映
          return acc;
        }, {});
      },
      set(value) {
        this.$store.commit("issuance_request_form/updateCheckedDocuments", 
          this.issueDocuments.map(doc => ({
            ...doc,
            checked: value[doc.id] || false // 画面のチェック状態を適用
          }))
        );
      },
    },
    options() {
      return this.issueDocuments.map(doc => ({
        id: doc.id,
        text: `${doc.name}（${doc.price}円）`,
        checked: doc.checked,
        disabled: doc.is_required === 1, // 必須のものは編集不可
      }));
    },
    editMode() {
      return !!this.$store.state[this.vuex_module]?.data?.id;
    },
    warningMessage() {
      return this.$store.state[this.vuex_module]?.warnings?.[this.vuex_column]?.[0];
    },
  },
}
</script>

<style scoped>
select {
  min-width: 250px;
}
</style>
